/* Core & libraries */
import React, {useContext, createContext, useState} from "react";

/* Helpers, constants, custom methods, internal libraries */
import { ACCEPTED_LANGUAGES, DEFAULT_LOCALE} from "../constants/appConstants";
import {storageFactory} from "factory/storageFactory";
/* Components */
/* Styles */

const LocaleContext = createContext({});
const LocaleUpdateContext = createContext({});

export function useLocaleContext() {
  return useContext(LocaleContext);
}

export function useLocaleUpdateContext() {
  return useContext(LocaleUpdateContext);
}

const localStore = storageFactory(() => localStorage);

export function LocaleProvider({children}) {
  let currentLocale = localStore.getItem('locale') || DEFAULT_LOCALE;
  if (!ACCEPTED_LANGUAGES[currentLocale]) {
    currentLocale = DEFAULT_LOCALE;
    localStore.setItem('locale', currentLocale);
  }
  const [locale, setLocale] = useState(currentLocale);

  //context can store also functions, such as setters within the context itself
  const changeLocale = (newLocale) => {
    setLocale(newLocale);
    localStore.setItem("locale", newLocale);
  };

  return (
    <LocaleContext.Provider value={locale} displayName="LocaleStore">
      <LocaleUpdateContext.Provider value={changeLocale} displayName="LocaleUpdateStore">
        {children}
      </LocaleUpdateContext.Provider>
    </LocaleContext.Provider>
  );
}
